import { getChainOptions, WalletProvider } from '@terra-money/wallet-provider';
import ReactDOM from 'react-dom';
import {
  Switch,
  Route,
  BrowserRouter as Router,
} from "react-router-dom";
import {
  ChakraProvider,
  extendTheme,
  type ThemeConfig,
} from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "react-query";
import Nav from "components/Nav/Nav";
import Main from "pages/Home/main";
import "./style.css";
import ProviderWrapper from "Wrappers/ProviderWrapper";
import Footer from "components/Footer/Footer";

function App() {
  const queryClient = new QueryClient();

  const config: ThemeConfig = {
    initialColorMode: "light",
    useSystemColorMode: false,
  };

  const theme = extendTheme({ config });

  return (
    <Router>
      <ChakraProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <ProviderWrapper>
            <Nav />
            <Main />
            <Footer />
          </ProviderWrapper>
        </QueryClientProvider>
      </ChakraProvider>
    </Router>
  );
}

getChainOptions().then((chainOptions) => {
  ReactDOM.render(
    <WalletProvider {...chainOptions}>
      <App />
    </WalletProvider>,
    document.getElementById('root'),
  );
});
